import { Link } from 'react-router-dom';
import { StatusPill } from '../common/StatusPill.jsx';
import { fullName, initials } from '../../lib/names.js';

/**
 * Single staff card — a row in the staff list grid.
 *
 * Tapping the card navigates to /dashboard/staff/:id for editing.
 * Status pill sits inside the card rather than beside a "name + status"
 * row because it reads better when the role is a secondary line underneath.
 */
export function StaffCard({ staff }) {
  return (
    <Link to={`/dashboard/staff/${staff.id}`} className="staff-card">
      {staff.photo_url ? (
        <img className="staff-avatar" src={staff.photo_url} alt="" />
      ) : (
        <div className="staff-avatar staff-avatar-placeholder">
          {initials(staff)}
        </div>
      )}

      <div className="staff-card-body">
        <h3 className="staff-card-name">{fullName(staff)}</h3>
        {staff.role && <p className="staff-card-role">{staff.role}</p>}
        <div className="staff-card-footer">
          <StatusPill status={staff.status} />
        </div>
      </div>
    </Link>
  );
}
